import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { useService } from 'shared/providers';
import { ContractDocument } from 'shared/types';

export function useCreateContract() {
  const queryClient = useQueryClient();
  const { contractService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation<ContractDocument, Error, ContractDocument>(
    request => contractService.createNewContract(request),
    {
      onSuccess: data => {
        queryClient.invalidateQueries('contracts');
        enqueueSnackbar('Contract was created', { variant: 'success' });
      },
      onError: () => {
        enqueueSnackbar('Contract was not created', { variant: 'error' });
      },
    }
  );

  return mutation;
}
